export const storageUnify = typeof window !== 'undefined' ? window.localStorage : {
  getItem: () => '',
  setItem: () => {},
  removeItem: () => {},
  clear: () => {},
  length: 0,
  key: () => '',
};